export default __webpack_public_path__ + "static/media/logo.fb67f911.png";